// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fms0O","option":"styles_option__2OwEY","active":"styles_active__1JPxD"};